import { render, staticRenderFns } from "./SearchTransfers.vue?vue&type=template&id=180b91fe&scoped=true"
import script from "./SearchTransfers.vue?vue&type=script&lang=js"
export * from "./SearchTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180b91fe",
  null
  
)

export default component.exports